export default {
  // Page title
  'page.title': 'ストップウォッチ',

  // How to use
  'howto.title': '使い方',
  'howto.step1': '「スタート」ボタンをクリックしてストップウォッチを開始します。表示形式：分:秒.センチ秒',
  'howto.step2': 'ストップウォッチ実行中に「一時停止」をクリックして計時を停止し、再度「スタート」をクリックして続行できます',
  'howto.step3': '「リセット」ボタンをクリックしてストップウォッチをゼロに戻し、計時を停止します',
  'howto.step4': 'ストップウォッチはミリ秒精度の表示をサポートしており、精密な計時が必要なシーンに適しています',

  // User reviews
  'reviews.title': 'ユーザーレビュー',
  'reviews.michaelRunner': 'トレーニングに欠かせないツール！ミリ秒精度で各スプリントのパフォーマンスを正確に記録でき、操作もシンプルで速いです。',
  'reviews.chefJohnson': '料理タイマーの魔法！炒め物、麺茹で、卵の蒸し料理など、すべて正確な計時が必要です。このストップウォッチのおかげで完璧な料理が作れます。',
  'reviews.sarahStudent': '試験シミュレーションに必須！解答時間の練習に使用し、シンプルなインターフェースで注意が散らされず、解答効率が向上しました。',
  'reviews.coachWilliams': 'トレーニングコースの素晴らしいアシスタント！インターバルトレーニングやプランクには正確な計時が必要で、生徒たちも気に入っています。',
  'reviews.drAnderson': '医療の仕事では正確な計時が頻繁に必要です。このストップウォッチはシンプルで信頼性が高く、臨床業務の優れたアシスタントです。',

  // User names
  'user.michaelRunner': 'マイケル・ランナー',
  'user.chefJohnson': 'シェフ・ジョンソン',
  'user.sarahStudent': 'サラ・学生',
  'user.coachWilliams': 'コーチ・ウィリアムズ',
  'user.drAnderson': 'アンダーソン医師',

  // Keywords section
  'keywords.stopwatch': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.chinese': '秒表 计时器 精确计时 现在几点',
  'keywords.japanese': 'ストップウォッチ タイマー 精密計時 今何時',
  'keywords.spanish': 'cronómetro temporizador tiempo preciso qué hora',
  'keywords.german': 'Stoppuhr Timer präzise Zeit wie spät',
  'keywords.french': 'chronomètre minuteur temps précis quelle heure',
  'keywords.russian': 'секундомер таймер точное время который час',
};
